<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <line class="a" x1="2.831" y1="20.2" x2="21.581" y2="2.2" />

        <path
            class="a"
            d="M 9.012 18.252 C 9.996 18.557 11.02 18.708 12.049 18.7 C 16.149 18.768 20.307 15.886 22.873 13.062 C 23.444 12.43 23.444 11.469 22.873 10.837 C 21.944 9.817 20.914 8.893 19.799 8.079"
        />

        <path
            class="a"
            d="M 14.462 5.482 C 13.673 5.287 12.862 5.192 12.049 5.2 C 8.017 5.134 3.849 7.952 1.227 10.836 C 0.657 11.468 0.657 12.429 1.227 13.061 C 2.022 13.934 2.89 14.737 3.821 15.461"
        />

        <path class="a" d="M 8.298 11.95 C 8.298 9.879 9.978 8.2 12.049 8.2" />

        <path
            class="a"
            d="M 15.798 11.949 C 15.799 14.02 14.121 15.7 12.049 15.7"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'EyeCrossedIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
